var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-layout",
        {
          staticClass: "section-title",
          attrs: { column: "", "justify-center": "" }
        },
        [_c("div", [_vm._v("requisitado por")]), _vm._v(" "), _c("hr")]
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "", "align-center": "" } },
        [
          _c(
            "v-radio-group",
            {
              attrs: { row: "" },
              model: {
                value: _vm.requester,
                callback: function($$v) {
                  _vm.requester = $$v
                },
                expression: "requester"
              }
            },
            [
              _c("v-radio", { attrs: { label: "Cliente", value: "customer" } }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: { label: "Profissional", value: "professional" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-layout", { attrs: { row: "", "justify-center": "" } }, [
        _c("p", { staticClass: "accent--text" }, [
          _vm._v(
            "\n      As regras se aplicarão conforme a escolha acima!\n    "
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9b9cc2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9b9cc2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Orders/Rebooking/RequiredBy.vue
// module id = null
// module chunks = 